import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { AuthRouteSkeleton } from '../../layout/ReusableComponent/Skeleton/RouteSkeletons';
import '../../layout/ReusableComponent/Skeleton/RouteSkeletons.css';

const CashflowAuthContext = createContext({ isAuthenticated: false, authChecked: false });

export function useCashflowAuth() {
  return useContext(CashflowAuthContext);
}

/**
 * Allows unauthenticated access for public group viewing.
 * List/create routes should redirect guests to sign-in.
 */
export default function CashflowGuestRoute({ children }) {
  const [authChecked, setAuthChecked] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const validateSession = useCallback(async () => {
    try {
      const response = await axios.post('/api/validate-session', {}, { withCredentials: true });
      setIsAuthenticated(response.data.success === true);
    } catch {
      setIsAuthenticated(false);
    } finally {
      setAuthChecked(true);
    }
  }, []);

  useEffect(() => {
    validateSession();
  }, [validateSession]);

  if (!authChecked) {
    return <AuthRouteSkeleton />;
  }

  return (
    <CashflowAuthContext.Provider value={{ isAuthenticated, authChecked }}>
      {children}
    </CashflowAuthContext.Provider>
  );
}
